var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"xs":"12","sm":"6","offset-sm":"3","md":"4","offset-md":"4"}},[_c('v-img',{attrs:{"src":"/piguet.svg"}})],1),_c('v-col',{attrs:{"xs":"12","sm":"6","offset-sm":"3","md":"4","offset-md":"4"}},[_c('cmp-login',{on:{"login":function($event){return _vm.login()}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }